import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { IBlogItemOverview } from 'common/types/blog';

import { BlogItem } from '../BlogItem';

import 'swiper/css';
import 'swiper/css/pagination';

export const BlogItemsLatest = ({
  blogs,
  dark = true,
}: {
  blogs: IBlogItemOverview[];
  dark: boolean;
}) => {
  const { t } = useTranslation('blogItemsOverview');

  return (
    <section
      className={clsx('relative overflow-hidden pt-10', {
        'bg-gradient': dark,
        'bg-white': !dark,
      })}
      id="blogItemsLatest">
      <Swiper
        style={{ paddingLeft: 20, paddingRight: 20 }}
        spaceBetween={10}
        slidesPerView={1}
        modules={[Pagination]}
        pagination={{ clickable: true }}
        breakpoints={{
          600: { slidesPerView: 1 },
          1020: { slidesPerView: 2.2 },
          1600: { slidesPerView: 3.2 },
          2200: { slidesPerView: 3.2 },
        }}>
        {!!blogs.length &&
          blogs.map((blog: IBlogItemOverview) => (
            <SwiperSlide key={blog.slug}>
              <BlogItem blog={blog} />
            </SwiperSlide>
          ))}
      </Swiper>
    </section>
  );
};

export default BlogItemsLatest;
